import React, { useContext, useEffect, useState } from "react";
import { message, Spin } from "antd";
import AuthContext from "../../Context/auth-context";
import { LoadingOutlined } from "@ant-design/icons";
import visibleImg from "../../Assets/img/visible.svg";
import "./Login.scss";
import Button from "../../Components/Button/Button";
import logo from "../../Assets/img/logoArabic.svg";
import design from "../../Assets/img/loginDesign.svg";
import logoWord from "../../Assets/img/sehatechColored.svg";
import { useTranslation } from "react-i18next";
import Turnstile, { useTurnstile } from "react-turnstile";

const Login = (props) => {
  const { t } = useTranslation();
  const turnstile = useTurnstile();
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#fff" }} spin />
  );
  const authContext = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [firebaseToken] = useState("");
  const [captchaToken, setCaptchaToken] = useState(""); // New state for Turnstile token

  useEffect(() => {
    setLoading(authContext.Loading);
  }, [authContext]);

  const login = (e) => {
    if (!email.length || !password)
      return message.error("Please fill all inputs");
    if (email.length < 6 || password.length < 6)
      return message.error("Min length is 6");
    if (!captchaToken && !process.env.REACT_APP_SKIP_CAPTCHA) 
      return message.error("Please complete the CAPTCHA");

    authContext.onLogin(e, email, password, firebaseToken, captchaToken); // Pass captchaToken to your login function
  };

  return (
    <>
      <div className="auth">
        <div className="login-right-cont">
          <span className="login-right-inner-cont">
            <p className="login-title">
              مرحبا بك في منصة
              <img
                alt="logo"
                src={logoWord}
                style={{ margin: "0 5px 5px 5px", width: "4.2em" }}
              />
              لمزودي الخدمة
            </p>
            <p className="login-subtitle">ادخل بياناتك لتسجيل الدخول</p>
          </span>
          <span className="login-rigth-input-cont">
            <input
              type="email"
              className="inputEmail"
              required
              name="email"
              placeholder={t("PLACEHOLDER.email")}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault(); // Prevent form submission
                  login(event); // Call your login function
                }
              }}
            />
            <span className="inputPass">
              <input
                type={isVisible ? "text" : "password"}
                className="input"
                required
                name="password"
                placeholder={t("PLACEHOLDER.password")}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault(); // Prevent form submission
                    login(event); // Call your login function
                  }
                }}
              />
              <img
                alt="background"
                src={visibleImg}
                onClick={() => setIsVisible(!isVisible)}
                style={{ color: "#1cc9bc", margin: "auto", cursor: "pointer" }}
              />
            </span>
            <p className="forgetPass">هل نسيت كلمة السر ؟</p>

            {!process.env.REACT_APP_SKIP_CAPTCHA && <Turnstile
              sitekey={process.env.REACT_APP_CAPTCHA_SITEKEY} // Replace with your actual site key
              onSuccess={(token) => setCaptchaToken(token)} // Capture token
              onError={() => message.error("CAPTCHA validation failed")}
              theme="light"
              onExpire={() => {
                setCaptchaToken("");
                message.warning("CAPTCHA expired, please try again");
              }}
            />}
            
          </span>
          <Button
            type="submit"
            theme="primary"
            style={{ marginTop: "1.5em", width: "-webkit-fill-available" }}
            disabled={loading}
            clicked={(e) => login(e)}
          >
            {!loading ? (
              <p className="login-btn">{t("LOGIN.LOGIN")}</p>
            ) : (
              <Spin size="small" indicator={antIcon} />
            )}
          </Button>
        </div>
        <div className="login-left-cont">
          <img alt="logo" className="logo" src={logo} />
          <img alt="logoDesign" className="loginDesign" src={design} />
        </div>
      </div>
    </>
  );
};

export default Login;
